export const NACE_COMPETENCIES = [
  'Leadership',
  'Communication',
  'Teamwork',
  'Equity & Inclusion',
  'Career & Self-Development',
  'Professionalism',
  'Critical Thinking',
  'Technology',
] as const;

export type NaceCompetency = typeof NACE_COMPETENCIES[number];
